import { IconPackRegistry } from './types'
import fontAwesomeSolidPack from './fontAwesomeSolidPack'
import fontAwesomeRegularPack from './fontAwesomeRegularPack'
import heroiconsSolidPack from './heroiconsPack'
import materialIconsPack from './materialIconsPack'
import featherIconsPack from './featherIconsPack'
import phosphorIconsPack from './phosphorIconsPack'

const iconPackRegistry: IconPackRegistry = {
  'font-awesome-solid': fontAwesomeSolidPack,
  'font-awesome-regular': fontAwesomeRegularPack,
  'heroicons-solid': heroiconsSolidPack,
  'material-icons': materialIconsPack,
  'feather-icons': featherIconsPack,
  'phosphor-icons': phosphorIconsPack,
}

console.log(
  'Heroicons Solid icons:',
  heroiconsSolidPack.icons.length,
  heroiconsSolidPack.icons.slice(0, 5)
)

// Log available icons for debugging
console.log('Available icon packs:', Object.keys(iconPackRegistry))

export default iconPackRegistry
